export const downloadCSV = ({ data, headersMap, filename = 'data.csv', arrayFieldMap = {} }) => {
    if (!data || data.length === 0) return;

    // Build header row
    const headers = Object.values(headersMap);
    const csvRows = [headers.join(',')];

    // Build data rows
    data.forEach((row) => {
        const values = Object.keys(headersMap).map((key) => {
            let val = row[key] ?? '';

            if (Array.isArray(val) && arrayFieldMap[key]) {
                const requiredKey = arrayFieldMap[key];
                val = val.map((ele) => ele[requiredKey]).join(', ');
            }

            // Escape quotes and commas
            val = String(val).replace(/"/g, '""');
            if (val.includes(',') || val.includes('"')) {
                val = `"${val}"`;
            }
            return val;
        });
        csvRows.push(values.join(','));
    });

    // Create blob and trigger download
    const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
};
